'use client';

import React, { useState } from 'react';
import { authenticatedPost } from '../lib/api/authenticated-fetch';

interface ShareChatModalProps {
  chatId: string;
  apiBaseUrl?: string;
  onClose: () => void;
  onSuccess: () => void;
}

export function ShareChatModal({
  chatId,
  apiBaseUrl = '/api/meridian-v2',
  onClose,
  onSuccess,
}: ShareChatModalProps) {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    setIsLoading(true);
    setError(null);

    try {
      const data = await authenticatedPost<any>(`${apiBaseUrl}/chats/share?chatId=${encodeURIComponent(chatId)}`, {
        recipientEmail: email,
      });
      if (data.success) {
        onSuccess();
      } else {
        setError(data.error || 'Failed to share chat');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to share chat');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <h2 className="text-xl font-semibold mb-4">Share Chat</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter recipient's email"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
            disabled={isLoading}
          />

          {error && <p className="text-red-500 text-sm mb-4">{error}</p>}

          <div className="flex gap-2">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 disabled:bg-gray-400"
              disabled={isLoading || !email.trim()}
            >
              {isLoading ? 'Sharing...' : 'Share'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

